import { DataPayload } from 'types/reduxTypes/ActionTypes';
import { EditMemberType } from 'types/people';
import { SetFieldType } from 'types/reduxTypes/ActionTypes/PeopleTypes';

export const types = {
  SET_FIELD: 'SET_FIELD',
  SET_ALL: 'SET_ALL',
  SET_EMIRATES_ID_PEOPLE: 'SET_EMIRATES_ID_PEOPLE',
  SHOW_ERROR: 'SHOW_ERROR',
  SET_VISA: 'SET_VISA',
  SET_PASSPORT: 'SET_PASSPORT',
}

export const setAll = (payload: DataPayload<EditMemberType>) => ({
  type: types.SET_ALL,
  payload,
});

export const setField = (payload: SetFieldType) => ({
  type: types.SET_FIELD,
  payload,
});

export const setEmiratesId = (payload: DataPayload<string | Blob>) => ({
  type: types.SET_EMIRATES_ID_PEOPLE,
  payload,
});

export const setShowError = (payload: SetFieldType) => ({
  type: types.SHOW_ERROR,
  payload,
});

export const setVisa = (payload: DataPayload<string | Blob>) => ({
  type: types.SET_VISA,
  payload,
});

export const setPassport = (payload: DataPayload<string | Blob>) => ({
  type: types.SET_PASSPORT,
  payload,
});
